const state = {
    show: false,
    text: '',
    color: 'info',
    id: 0,
}

const mutations = {
    setSnackbarMessage(state, {text, color}) {
        state.text = text;
        state.color = color;
        state.show = true;
        state.id++
    },
}

export const snackbar = {
    namespaced: true,
    state,
    mutations
}